import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-loading-bar',
    template: ` <mat-progress-bar class="u-w100p" mode="indeterminate"></mat-progress-bar> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBarComponent {}
